const USER = 'user';
const AZURE_ID_TOKEN = 'azure.id-token';
const EMPLOYEE_AVATAR = 'employeeAvatar';
const AZURE_ACCESS_TOKEN = 'azure.access-token';
export default {
  setEmployeeAvatar(base64Image) {
    try {
      localStorage.setItem(EMPLOYEE_AVATAR, base64Image);
    } catch (e) {
      console.error('Failed to set employee avatar in localStorage.', e);
    }
  },

  getEmployeeAvatar() {
    return localStorage.getItem(EMPLOYEE_AVATAR) || null;
  },

  clearEmployeeAvatar() {
    localStorage.removeItem(EMPLOYEE_AVATAR);
  },

  getObject(key) {
    let value = localStorage.getItem(key) || '{}';
    try {
      return JSON.parse(value);
    } catch (e) {
      console.error('getObject from localStorage failed. Recovering by returning empy object', e);
      return {};
    }
  },
  setObject(key, value) {
    try {
      localStorage.setItem(JSON.stringify(value));
    } catch (e) {
      console.error('setObject to localStorage failed. Recovering with setting empty object', e);
      localStorage.setItem('{}');
    }
  },
  getUser() {
    return this.getObject(USER);
  },
  setUser(userObject) {
    this.setObject(USER, userObject);
  },

  getAzureIdToken() {
    return localStorage.getItem(AZURE_ID_TOKEN);
  },
  setAzureIdToken(idToken) {
    localStorage.setItem(AZURE_ID_TOKEN, idToken);
  },
  clearAzureIdToken() {
    localStorage.removeItem(AZURE_ID_TOKEN);
  },
  getAzureAccessToken() {
    return localStorage.getItem(AZURE_ACCESS_TOKEN);
  },
  setAzureAccessToken(accessToken) {
    localStorage.setItem(AZURE_ACCESS_TOKEN, accessToken);
  },
  clearAzureAccessToken() {
    localStorage.removeItem(AZURE_ACCESS_TOKEN);
  },
};
